import StudentApplicationForm from './StudentApplicationForm'

export default StudentApplicationForm
